import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledBasicToolbar,
  StyledHeader,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';

export const StablecoinsHeader = () => {
  const { isDesktop } = useBreakpointsCtx();

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledBasicToolbar>
        <StyledAgioH1
          noWrap
          color="customSecondary.primary.DEFAULT"
          data-testid="stablecoins-header-title"
        >
          Stablecoins
        </StyledAgioH1>
      </StyledBasicToolbar>
    </StyledHeader>
  );
};
